<template>
  <drag-modal :visible="$store.state.dislog.Car" @cancel="reset" :title="title" width="660px">
    <div class="hisform">
      <div v-if="type == 1">
        <a-form-model ref="forms" :model="form" :rules="formrules" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-form-model-item label="财产类型">
            <a-radio-group v-model="type" @change="typeChanges">
              <a-radio :value=1> 车辆 </a-radio>
              <a-radio :value=3 :disabled="title != '新增财产信息'"> 账户 </a-radio>
              <a-radio :value=2 :disabled="title != '新增财产信息'"> 房产 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="车架号" prop="vin">
            <a-input v-model="carInfo.vin" placeholder="请输入" :disabled="see" @blur="getCarInfo" />
          </a-form-model-item>
          <a-form-model-item label="车辆品牌">
            <a-input v-model="carInfo.name" disabled />
          </a-form-model-item>
          <a-form-model-item label="排量/排放">
            <a-input-group style="display: flex;gap: 5px;align-items: center;height: 100%;margin-top: 5px;">
              <a-input v-model="carInfo.displacement" disabled placeholder="请输入" style="flex: 1;" />
              <a-input v-model="carInfo.environmentalstandards" disabled placeholder="请输入"
                style="flex: 1;border-radius: 4px;" />
            </a-input-group>
          </a-form-model-item>
          <a-form-model-item label="车牌号码/颜色" prop="carInfos">
            <a-input-group style="display: flex;gap: 5px;margin-top: 5px;">
              <a-input :maxLength="10" type="text" v-model="form.number" placeholder="请输入" :disabled="see" />
              <a-input style="border-radius: 4px;" :maxLength="50" type="text" v-model="form.color" placeholder="请输入"
                :disabled="see" />
            </a-input-group>
          </a-form-model-item>
          <a-form-model-item label="估值时间/估值">
            <a-button style="width: 40px;font-size: 1.25rem;" @click="addvaluation" type="link" icon="plus-circle"
              v-if="!see && form.valuationList.length == 0" />
            <div v-for="(item, index) in form.valuationList" :key="index"
              style="display: flex;position: relative;margin:5px 0" v-else>
              <a-input-group style="display: flex;gap: 5px;width: 100%;align-items: center;">
                <a-form-model-item :prop="`valuationList.${index}.valuation_time`" :rules="valuation_timeRules"
                  style="margin-bottom:0;width: 100%;">
                  <a-date-picker v-model="item.valuation_time" placeholder="请选择" format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD" :allowClear="false" style="width: 100%;display: flex;align-items: center;"
                    :disabled="see" />
                </a-form-model-item>
                <a-form-model-item :prop="`valuationList.${index}.valuation_fee`" :rules="valuation_feeRules"
                  style="margin-bottom:0;width: 100%;">
                  <a-input style="border-radius: 4px;width: 100%;" type="text" :maxLength="10"
                    v-model="item.valuation_fee" placeholder="请输入估值" :disabled="see" />
                </a-form-model-item>
              </a-input-group>
              <div class="addbtns" v-if="!see">
                <a-icon type="plus-circle" class="i add" @click="addvaluation" v-if="index == 0" />
                <a-icon type="minus-circle" class="i del" @click='delsvaluation(index)' v-else />
              </div>
            </div>
          </a-form-model-item>
          <a-form-model-item label="车辆登记人" prop="debtor_id">
            <a-select style="width: 100%;" v-model="form.debtor_id" placeholder="请选择" :disabled="see">
              <a-select-option v-for="row in iData.parties.defendant" :key="row.id" :value="row.id">{{ row.realname
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item label="排放">
            <a-input v-model="carInfo.environmentalstandards" disabled />
          </a-form-model-item> -->
          <a-form-model-item label="初登时间" prop="registration_time">
            <a-date-picker v-model="form.registration_time" placeholder="请选择" format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD" style="width: 100%;" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="车辆状态" prop="state">
            <a-select style="width: 100%;" v-model="form.state" placeholder="请选择" :disabled="see">
              <a-select-option v-for="i in byTypeObject.car_status" :key="i.id" :value="i.id">{{ i.option_name
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item label="年检时间" prop="yearly_inspection_time">
            <a-date-picker v-model="form.yearly_inspection_time" placeholder="请选择" format="YYYY-MM-DD"
              style="width: 100%;" valueFormat="YYYY-MM-DD" :disabled="see" />
          </a-form-model-item> -->
          <a-form-model-item label="抵押权人" prop="mortgagee">
            <a-input :maxLength="50" type="text" v-model="form.mortgagee" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="保全状态" prop="preservation_status">
            <a-select style="width: 100%;" v-model="form.preservation_status" placeholder="请选择" :disabled="see"
              @select="selectclick">
              <a-select-option v-for="i in byTypeObject.preservation_status" :key="i.id">{{ i.option_name
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <div v-if="this.preservationTime == 'BQ001' || this.preservationTime == 'BQ002' || this.preservationTime == 'BQ005'">
            <a-form-model-item label="保全时间" prop="preservation_time" :required="isPreserveRequired">
              <a-date-picker style="width: 100%;" :value='form.preservation_time' format="YYYY-MM-DD" type="date"
                valueFormat="YYYY-MM-DD" @change='(e, s) => { form.preservation_time = s }' :disabled='see' />
            </a-form-model-item>
            <a-form-model-item label="保全到期时间" prop="preservation_expired_time" :required="isPreserveRequired">
              <a-date-picker style="width: 100%;" :value='form.preservation_expired_time' format="YYYY-MM-DD"
                type="date" valueFormat="YYYY-MM-DD" @change='(e, s) => { form.preservation_expired_time = s }'
                :disabled='see' />
            </a-form-model-item>
          </div>
          <a-form-model-item label="拍卖信息" prop="">
            <div style="display: flex;gap: 5px;align-items: center;margin-bottom: 10px;position: relative;"
              v-for="(item, index) in form.auctionList" :key="index">
              <div :class="['boxboder', see ? 'boxboders' : '']" v-if="item">
                <div @click="see ? '' : editAuc(item, index)">
                  <div>状态：<span>{{ transformation(item.auction_status, 'auction_status') }}</span> </div>
                  <div>阶段：<span>{{ transformation(item.auction_step, 'auction_step') }}</span> </div>
                  <div>估值：<span>{{ item.value }}</span> </div>
                  <div>开始时间：<span>{{ item.auction_start_time }}</span>
                  </div>
                </div>
                <a-icon type="form" :class="[see ? '' : 'icon']" @click="see ? '' : editAuc(item, index)" />
              </div>
              <div class="addbtns" v-if="!see">
                <a-icon type="plus-circle" class="i add" v-if="index == 0" @click="addAuc" />
                <a-icon type="minus-circle" class="i del" @click='delauction(index)' v-else />
              </div>
            </div>
            <a-button style="width: 40px;font-size: 1.25rem;" @click="addAuc" type="link" icon="plus-circle"
              v-if="!see && form.auctionList.length == 0" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" prop="files"
            :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
            <Upload breadth="250px" @isDisabled="parentHandle" :fList='form.files' @upFileAfter='lisUpload'
              :Wid='"153px"' :edit='see' :disabled="see" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }" v-if="!see">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="addform1">
              <a-button type="primary" style="width: 148px"> 保存 </a-button>
            </a-popconfirm>
            <a-button style="margin-left: 20px;width: 148px;background: #b2c9e1;color: #fff;"
              @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div v-if="type == 3">
        <a-form-model ref="forms" :model="form3" :rules="form3rules" :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }">
          <a-form-model-item label="财产类型">
            <a-radio-group v-model="type" @change="typeChanges">
              <a-radio :value=1 :disabled="title != '新增财产信息'"> 车辆 </a-radio>
              <a-radio :value=3> 账户 </a-radio>
              <a-radio :value=2 :disabled="title != '新增财产信息'"> 房产 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="账户类型" prop="account_type">
            <a-select v-model="form3.account_type" placeholder="请选择" :disabled="see">
              <a-select-option :value="1">储蓄账户</a-select-option>
              <a-select-option :value="2">活期账户</a-select-option>
              <a-select-option :value="3">定期账户</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="开户行" prop="opening_bank">
            <a-input :maxLength="50" type="text" v-model="form3.opening_bank" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="户名" prop="debtor_id">
            <a-select style="width: 100%;" v-model="form3.debtor_id" placeholder="请选择" :disabled="see">
              <a-select-option v-for="row in iData.parties.defendant" :key="row.id" :value="row.id">{{ row.realname
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="银行账号" prop="account_bank">
            <a-input :maxLength="50" type="text" v-model="form3.account_bank" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <!-- <a-form-model-item label="绑定的手机号码" prop="phoneNumber">
            <a-input :maxLength="50" type="text" v-model="form3.phoneNumber" placeholder="请输入" :disabled="see" />
          </a-form-model-item> -->
          <a-form-model-item label="账户状态" prop="account_status">
            <a-select v-model="form3.account_status" placeholder="请选择" :disabled="see">
              <a-select-option :value="1">挂失</a-select-option>
              <a-select-option :value="2">销户</a-select-option>
              <a-select-option :value="3">冻结</a-select-option>
              <a-select-option :value="4">正常使用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="保全状态" prop="preservation_status">
            <a-select style="width: 100%;" v-model="form3.preservation_status" placeholder="请选择" :disabled="see"
              @select="selectclick">
              <a-select-option v-for="i in deletePreservation_status" :key="i.id">{{ i.option_name
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <div v-if="this.preservationTime == 'BQ001' || this.preservationTime == 'BQ002'">
            <a-form-model-item label="保全时间" prop="preservation_time" :required="isPreserveRequired">
              <a-date-picker style="width: 100%;" :value='form3.preservation_time' format="YYYY-MM-DD" type="date"
                valueFormat="YYYY-MM-DD" @change='(e, s) => { form3.preservation_time = s }' :disabled='see' />
            </a-form-model-item>
            <a-form-model-item label="保全到期时间" prop="preservation_expired_time" :required="isPreserveRequired">
              <a-date-picker style="width: 100%;" :value='form3.preservation_expired_time' format="YYYY-MM-DD"
                type="date" valueFormat="YYYY-MM-DD" @change='(e, s) => { form3.preservation_expired_time = s }'
                :disabled='see' />
            </a-form-model-item>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" prop="files"
            :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
            <Upload breadth="250px" @isDisabled="parentHandle" :fList='form3.files' @upFileAfter='lisUpload'
              :Wid='"153px"' :edit='see' :disabled="see" />
          </a-form-model-item>
        </a-form-model>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }" v-if="!see">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="addform3">
            <a-button type="primary" style="width: 148px"> 保存 </a-button>
          </a-popconfirm>
          <a-button style="margin-left: 20px;width: 148px;background: #b2c9e1;color: #fff;" @click="reset">取消</a-button>
        </a-form-model-item>
      </div>
      <div v-if="type == 2">
        <a-form-model ref="forms" :model="form2" :rules="form2rules" :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }">
          <a-form-model-item label="财产类型">
            <a-radio-group v-model="type" @change="typeChanges">
              <a-radio :value=1 :disabled="title != '新增财产信息'"> 车辆 </a-radio>
              <a-radio :value=3 :disabled="title != '新增财产信息'"> 账户 </a-radio>
              <a-radio :value=2> 房产 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="房产地址" prop="dwell">
            <a-cascader :options="options" placeholder="请选择"
              :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form2.dwell'
              :disabled='see' />
            <a-input v-model="form2.detail_address" type='textarea' style="margin-top:20px;" placeholder="请输入详细地址"
              :disabled='see' />
          </a-form-model-item>
          <a-form-model-item label="产权人姓名" prop="debtor_id">
            <a-select style="width: 100%;" v-model="form2.debtor_id" @change="debtorChange" placeholder="请选择"
              :disabled="see">
              <a-select-option v-for="row in iData.parties.defendant" :key="row.id" :value="row.id">{{ row.realname
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="产权人身份证号码">
            <a-input :maxLength="50" type="text" v-model="form2.cardNumber" disabled />
          </a-form-model-item>
          <a-form-model-item label="不动产权证书号" prop="cert_no">
            <a-input :maxLength="50" type="text" v-model="form2.cert_no" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="土地使用权面积" prop="land_area">
            <a-input :maxLength="50" type="text" v-model="form2.land_area" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="房屋建筑面积" prop="build_area">
            <a-input :maxLength="50" type="text" v-model="form2.build_area" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="房屋性质" prop="nature">
            <a-select v-model="form2.nature" placeholder="请选择" :disabled="see">
              <a-select-option :value="1">住宅</a-select-option>
              <a-select-option :value="2">商业</a-select-option>
              <a-select-option :value="3">其他</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="抵押权人" prop="mortgagee">
            <a-input :maxLength="50" type="text" v-model="form2.mortgagee" placeholder="请输入" :disabled="see" />
          </a-form-model-item>
          <a-form-model-item label="登记日期" prop="registration_time">
            <a-date-picker style="width: 100%;" :value='form2.registration_time' format="YYYY-MM-DD" type="date"
              valueFormat="YYYY-MM-DD" @change='(e, s) => { form2.registration_time = s }' :disabled='see' />
          </a-form-model-item>
          <a-form-model-item label="房屋状态" prop="state">
            <a-select v-model="form2.state" placeholder="请选择" :disabled="see">
              <a-select-option :value="1">自住</a-select-option>
              <a-select-option :value="2">出租</a-select-option>
              <a-select-option :value="3">空置</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="保全状态" prop="preservation_status">
            <a-select style="width: 100%;" v-model="form2.preservation_status" placeholder="请选择" :disabled="see"
              @select="selectclick">
              <a-select-option v-for="i in byTypeObject.preservation_status" :key="i.id">{{ i.option_name
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <div v-if="this.preservationTime == 'BQ001' || this.preservationTime == 'BQ002' || this.preservationTime == 'BQ005'">
            <a-form-model-item label="保全时间" prop="preservation_time" :required="isPreserveRequired">
              <a-date-picker style="width: 100%;" :value='form2.preservation_time' format="YYYY-MM-DD" type="date"
                valueFormat="YYYY-MM-DD" @change='(e, s) => { form2.preservation_time = s }' :disabled='see' />
            </a-form-model-item>
            <a-form-model-item label="保全到期时间" prop="preservation_expired_time" :required="isPreserveRequired">
              <a-date-picker style="width: 100%;" :value='form2.preservation_expired_time' format="YYYY-MM-DD"
                type="date" valueFormat="YYYY-MM-DD" @change='(e, s) => { form2.preservation_expired_time = s }'
                :disabled='see' />
            </a-form-model-item>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" prop="files"
            :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
            <Upload breadth="250px" @isDisabled="parentHandle" :fList='form2.files' @upFileAfter='lisUpload'
              :Wid='"153px"' :edit='see' :disabled="see" />
          </a-form-model-item>
        </a-form-model>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }" v-if="!see">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="addform2">
            <a-button type="primary" style="width: 148px"> 保存 </a-button>
          </a-popconfirm>
          <a-button style="margin-left: 20px;width: 148px;background: #b2c9e1;color: #fff;" @click="reset">取消</a-button>
        </a-form-model-item>
      </div>
    </div>
    <Add :info="infos" ref="dislog" @update-auction="handleUpdateAuction"></Add>
  </drag-modal>
</template>
<script>
import moment from 'moment';
import Add from '../../auction/add.vue'
import { getCarInfo, AddCar, EditCar } from '@/server/car.js'
import { EditAccount, AddAccount, AddHouse, EditHouse } from '@/server/account.js'
import Upload from "@/components/uploads"
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
import { set } from 'core-js/core/dict';
export default {
  name: "Car",
  props: {
    info: {
      type: Object,
    },
    byTypeObject: Object,
    carOrHouse: Number,
    sees: Boolean,
    iData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: {
    Add,
    Upload
  },
  watch: {
    sees: {
      handler(newVal) {
        this.see = newVal
        switch (newVal) {
          case true:
            this.title = '查看财产信息'
            break
          case false:
            this.title = '修改财产信息'
            break
          default:
            this.title = '新增财产信息'
        }
      },
      immediate: true
    },
    carOrHouse: {
      handler(newVal) {
        this.type = newVal
      },
      immediate: true  // 立即执行一次
    },
    info: {
      handler(newVal) {
        if (newVal.clarify === '车辆') {
          if (newVal.id) {
            let list = newVal.auctionList.length > 0 ? newVal.auctionList.map(eles => {
              return {
                ...eles,
                value: eles.value / 100
              }
            }) : []
            this.form = {
              id: newVal.id,
              debtor_id: newVal.debtor_id,
              car_info_id: newVal.car_info_id,
              color: newVal.color,
              number: newVal.number,
              debtor_id: newVal.debtor_id,
              registration_time: newVal.registration_time,
              yearly_inspection_time: newVal.yearly_inspection_time,
              valuationList: newVal.valuationList,
              auctionList: list,
              state: newVal.state ? Number(newVal.state) : newVal.state,
              mortgagee: newVal.mortgagee,
              preservation_time: newVal.preservation_time,
              preservation_expired_time: newVal.preservation_expired_time,
              preservation_status: newVal.preservation_status ? Number(newVal.preservation_status) : newVal.preservation_status
            }
            newVal.files.map((ele) => {
              ele.title = ele.origin_name
              ele.upload_id = Number(ele.id)
            })
            this.form.files = newVal.files
            if (newVal.car) {
              this.carInfo = {
                vin: newVal.car.vin,
                name: newVal.car.name,
                displacement: newVal.car.displacement,
                environmentalstandards: newVal.car.environmentalstandards,
              }
            }
          }
          else {
            this.carInfo = {
              vin: '',
              name: '',
              displacement: '',
              environmentalstandards: '',
            }
            this.infos = {
              id: '',
              value: '',
              item_type: '',
              auction_status: '',
              auction_step: '',
              auction_start_time: null,
              car_license_number: '',
              files: []
            }
          }
        } else if (newVal.clarify === '账户') {
          if (newVal.id) {
            this.form3 = {
              id: newVal.id,
              debtor_id: newVal.debtor_id,
              account_type: newVal.account_type ? Number(newVal.account_type) : newVal.account_type,//账号类型
              opening_bank: newVal.opening_bank,//开户行
              account_bank: newVal.account_bank,//银行账号
              account_status: newVal.account_status ? Number(newVal.account_status) : newVal.account_status,//账户状态
              preservation_status: newVal.preservation_status ? Number(newVal.preservation_status) : newVal.preservation_status,//保全状态
              preservation_time: newVal.preservation_time,
              preservation_expired_time: newVal.preservation_expired_time,
              files: newVal.files
            }
          }
        } else {
          if (newVal.id) {
            this.form2 = {
              id: newVal.id,
              preservation_status: newVal.preservation_status ? Number(newVal.preservation_status) : newVal.preservation_status,
              detail_address: newVal.detail_address,
              debtor_id: newVal.debtor_id,
              cardNumber: newVal.debtor.chinaid,
              cert_no: newVal.cert_no,
              land_area: newVal.land_area,
              build_area: newVal.build_area,
              nature: newVal.nature ? Number(newVal.nature) : newVal.nature,
              mortgagee: newVal.mortgagee,
              registration_time: newVal.registration_time,
              state: newVal.state ? Number(newVal.state) : newVal.state,
              dwell: [newVal.province, newVal.city, newVal.district],
              preservation_time: newVal.preservation_time,
              preservation_expired_time: newVal.preservation_expired_time,
              files: newVal.files
            }
          }
        }
      },
      immediate: true,
    }
  },
  data() {
    const validateCarInfo = (rule, value, callback) => {
      const { number, color } = this.form;
      if (!number) {
        callback(new Error("请输入车牌号码"));
      } else if (!color) {
        callback(new Error("请输入车辆颜色"));
      } else {
        callback(); // 验证通过
      }
    };
    return {
      options: citySort(city),
      type: '1',
      carInfo: {},
      title: '新增财产信息',
      form: {
        id: '',
        debtor_id: undefined,
        car_info_id: '',
        color: '',
        number: '',
        registration_time: null,
        yearly_inspection_time: null,
        state: undefined,
        rights: '',
        preservation_status: undefined,
        mortgagee: '',
        preservation_time: null,
        preservation_expired_time: null,
        files: [],
        valuationList: [
          {
            valuation_time: '',
            valuation_fee: null
          }
        ],
        auction: [],
        auctionList: []
      },
      see: false,
      visible: false,
      loading: false,
      infos: {
        id: '',
        value: '',
        item_type: '',
        auction_status: '',
        auction_step: '',
        auction_start_time: null,
        car_license_number: '',
        files: []
      },
      visible1: false,
      form2: {
        preservation_time: null,
        preservation_expired_time: null,
        preservation_status: undefined,//保全状态
        detail_address: '',
        debtor_id: undefined,//产权人姓名
        cardNumber: '',//产权人身份证号码
        cert_no: '',//产权证号
        land_area: '',//土地面积
        build_area: '',//房屋面积
        nature: undefined,//房屋性质
        mortgagee: '',//抵押权人
        registration_time: null,//登记时间
        state: undefined,//房屋状态
        dwell: [],
        files: []
      },
      form3: {
        account_type: undefined,//账号类型
        opening_bank: '',//开户行
        account_bank: '',//银行账号
        phoneNumber: '',//手机号码
        account_status: undefined,//账户状态
        preservation_status: undefined,//保全状态
        preservation_time: null,
        preservation_expired_time: null,
        files: [],
      },
      preservationTime: '',
      disabledShow: false,
      formrules: {
        vin: [
          {
            required: true,
            message: '请输入车架号',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!this.carInfo.vin) {
                callback(new Error('请输入车架号'));
              } else {
                callback();
              }
            }
          },
          {
            pattern: /^[A-HJ-NP-Z0-9]{17}$/,
            message: '车架号格式错误（需17位字母/数字）',
            trigger: 'blur'
          }
        ],
        carInfos: [{ validator: validateCarInfo, trigger: "change" }],
        debtor_id: [{ required: true, message: '请选择车辆登记人', trigger: 'change' }],
        registration_time: [{ required: true, message: '请选择初登时间', trigger: 'change' }],
        state: [{ required: true, message: '请选择车辆状态', trigger: 'change' }],
        mortgagee: [{ required: true, message: '请输入抵押权人', trigger: 'blur' }],
        preservation_status: [{ required: true, message: '请选择保全状态', trigger: 'change' }],
        preservation_time: [{ validator: this.validatePreserveTime, trigger: 'change' }],
        preservation_expired_time: [{ validator: this.validatePreserveExpiredTime, trigger: 'change' }],
      },
      form2rules: {
        dwell: [{ required: true, message: '请选择房产地址', trigger: 'change' }],
        debtor_id: [{ required: true, message: '请选择产权人姓名', trigger: 'change' }],
        cert_no: [{ required: true, message: '请输入不动产权证书号', trigger: 'change' }],
        land_area: [{ required: true, message: '请输入土地使用权面积', trigger: 'change' }],
        build_area: [{ required: true, message: '请输入房屋建筑面积', trigger: 'change' }],
        nature: [{ required: true, message: '请选择房屋性质', trigger: 'change' }],
        mortgagee: [{ required: true, message: '请输入抵押权人', trigger: 'change' }],
        registration_time: [{ required: true, message: '请选择登记日期', trigger: 'change' }],
        state: [{ required: true, message: '请选择房屋状态', trigger: 'change' }],
        preservation_status: [{ required: true, message: '请选择保全状态', trigger: 'change' }],
        preservation_time: [{ validator: this.validatePreserveTime, trigger: 'change' }],
        preservation_expired_time: [{ validator: this.validatePreserveExpiredTime, trigger: 'change' }],
      },
      form3rules: {
        account_type: [{ required: true, message: '请选择账户类型', trigger: 'change' }],
        opening_bank: [{ required: true, message: '请输入开户行', trigger: 'change' }],
        debtor_id: [{ required: true, message: '请选择户名', trigger: 'change' }],
        account_bank: [{ required: true, message: '请输入银行账号', trigger: 'change' }],
        account_status: [{ required: true, message: '请选择账户状态', trigger: 'change' }],
        preservation_status: [{ required: true, message: '请选择保全状态', trigger: 'change' }],
        preservation_time: [{ validator: this.validatePreserveTime, trigger: 'change' }],
        preservation_expired_time: [{ validator: this.validatePreserveExpiredTime, trigger: 'change' }]
      },
      valuation_timeRules: [
        {
          validator: (rule, value, callback) => {
            if (!value || value === null || value === '') {
              callback('请选择时间')
              return
            }
            callback()
          },
          trigger: 'change'
        }
      ],
      valuation_feeRules: [
        {
          validator: (rule, value, callback) => {
            const i = rule.field.split('.')[1]
            const valuation_time = this.form.valuationList[i].valuation_time
            if ((valuation_time !== null && valuation_time !== '') && !value) {
              callback('请填写估值')
              return
            }
            callback()
          },
          trigger: 'change'
        }
      ]
    }
  },
  mounted() {
  },
  computed: {
    deletePreservation_status() {
      // 返回删除最后两个元素后的新数组
      return this.byTypeObject.preservation_status.slice(0, -2);
    }
  },
  methods: {
    selectclick(key) {
      // 找到匹配id的项，取出code
      const targetItem = this.byTypeObject.preservation_status.find(item => item.id === key);
      this.preservationTime = targetItem.code;
    },
    typeChanges(e) {
      this.preservationTime = ''
      this.type = e.target.value
      this.$refs.forms.clearValidate();
    },
    addvaluation() {
      this.form.valuationList.push({ valuation_fee: '', valuation_time: '' })
    },
    delsvaluation(index) {
      this.form.valuationList.splice(index, 1)
    },
    parentHandle(data) {
      this.disabledShow = data
    },
    lisUpload(fileList, list) {
      if (list && Array.isArray(list)) {
        const processedList = list.map((ele) => {
          if (!ele || typeof ele !== 'object') {
            return ele;
          }
          return {
            ...ele,
            origin_name: ele.title,
            id: ele.upload_id
          };
        });
        if (this.type == 1) {
          this.form.files = processedList;
        } else if (this.type == 2) {
          this.form2.files = processedList;
        } else {
          this.form3.files = processedList;
        }
      }
    },
    handleUpdateAuction(newData, type) {
      this.infos = newData
      if (type == 'add') {
        this.form.auctionList.push(newData)
      } else {
        if (newData.id) {
          const targetIndex = this.form.auctionList.findIndex(e => e.id === newData.id);
          if (targetIndex !== -1) {
            this.form.auctionList.splice(targetIndex, 1, {
              ...this.form.auctionList[targetIndex], // 保留原元素的其他字段
              value: newData.value > 0 ? newData.value : 0,
              item_type: newData.item_type,
              auction_status: newData.auction_status,
              auction_step: newData.auction_step,
              auction_start_time: newData.auction_start_time,
              car_license_number: newData.car_license_number,
              files: newData.files
            });
          }
        } else {
          this.form.auctionList[newData.index] = {
            value: newData.value > 0 ? newData.value : 0,
            item_type: newData.item_type,
            auction_status: newData.auction_status,
            auction_step: newData.auction_step,
            auction_start_time: newData.auction_start_time,
            car_license_number: newData.car_license_number,
            files: newData.files
          }
        }
      }
    },
    transformation(id, type) {
      const stage = {
        1: "一拍",
        2: "二拍",
        3: "变卖",
      };

      const status = {
        1: "即将开始",
        2: "扣押中", // 已取消注释
        3: "拍卖中",
        4: "已拍卖",
        5: "流拍",
      };

      const types = {
        1: '储蓄账户',
        2: '活期账户',
        3: '定期账户'
      }
      // 根据 type 参数选择对应的映射表
      const mapping = type === 'auction_status' ? status : type === 'account_type' ? types : stage;
      // 返回对应的文字，如果 id 不存在则返回 id 本身
      return mapping[id] || id;
    },
    addAuc() {
      this.$refs.dislog.edit = 1
      this.infos = {
        status: false
      }
      this.$refs.dislog.visible = true
    },
    editAuc(items, index) {
      if (items.id) {
        this.infos = {
          id: items.id,
          value: items.value,
          item_type: items.item_type,
          car_license_number: items.car_license_number,
          auction_status: items.auction_status,
          auction_start_time: items.auction_start_time,
          auction_step: items.auction_step,
          files: items.files,
          status: true
        }
      } else {
        this.infos = {
          value: items.value,
          item_type: items.item_type,
          car_license_number: items.car_license_number,
          auction_status: items.auction_status,
          auction_start_time: items.auction_start_time,
          auction_step: items.auction_step,
          files: items.files,
          status: true,
          index: index
        }
      }
      this.$refs.dislog.edit = 2
      this.$refs.dislog.visible = true
    },
    delauction(index) {
      this.form.auctionList.splice(index, 1)
    },
    debtorChange(val) {
      const item = this.iData.parties.defendant.find(e => e.id == val);
      this.form2.cardNumber = item ? item.chinaid : '';
    },
    // 统一提交处理财产
    submitForm(type, formData, apiAdd, apiEdit) {
      this.preservationTime = ''//保全时间判断是否显示
      const form = JSON.parse(JSON.stringify(formData))
      Object.keys(form).forEach(key => !form[key] && delete form[key])
      this.$refs.forms.validate(valid => {
        if (!valid) return
        if (type === 'car') {
          form.valuation = form.valuationList
          form.auction = form.auctionList.map(eles => {
            delete eles.status
            delete eles.index
            return {
              ...eles,
              value: eles.value > 0 ? (eles.value * 100).toFixed(0) : 0
            }
          })
        }
        const request = form.id ? apiEdit(form) : apiAdd(form)
        request.then(() => {
          this.$message.success({ content: '操作成功', key: 'updatable' })
          this.reset()
        })
      })
    },
    addform1() {
      this.form.valuationList = this.form.valuationList.filter(
        item => !(
          (!item.valuation_time) &&
          (!item.valuation_fee)
        )
      );
      this.submitForm('car', this.form, AddCar, EditCar)
    },
    addform2() {
      this.submitForm('house', this.form2, AddHouse, EditHouse)
    },
    addform3() {
      this.submitForm('account', this.form3, AddAccount, EditAccount)
    },
    reset() {
      if (this.type == 1) {
        this.form = {
          auctionList: [],
          valuationList: []
        }
      } else if (this.type == 2) {
        this.form2 = {}
      } else {
        this.form3 = {}
      }
      this.preservationTime = ''
      this.$emit('resh')
      this.$store.dispatch('openkey', { key: 'Car', by: false })
      this.$emit('update:num', this.type)
    },
    async getCarInfo() {
      if (this.carInfo.vin) {
        this.loading = true
        getCarInfo({ vin: this.carInfo.vin }).then(res => {
          this.carInfo.name = res.name
          this.carInfo.displacement = res.displacement
          this.carInfo.environmentalstandards = res.environmentalstandards
          this.form.car_info_id = res.id
          this.loading = false
        }).catch(e => {
          this.carInfo.name = ''
          this.carInfo.displacement = ''
          this.carInfo.environmentalstandards = ''
          this.form.car_info_id = ''
          this.form.preservation_status = ''
          this.form.status = ''
          this.rights = ''
          this.loading = false
        })
      }
    },
  },
}
</script>
<style lang="less">
.addbtns {
  position: absolute;
  display: flex;
  font-size: 20px;
  height: 30px;
  align-items: center;
  padding-left: 20px;
  right: -45px;
  top: 50%;
  transform: translateY(-50%);

  .i {
    cursor: pointer;
  }

  .mr {
    margin-right: 5px;
  }

  .add {
    color: #118afc;
  }

  .del {
    color: #f00;
  }
}

.hisform {
  textarea {
    width: 100%;
    height: 80px;
    border: 1px solid #efefef;
    padding: 4px 10px;
  }
}

.boxboder {
  width: 100%;
  min-height: 120px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  transition: border-color 0.3s ease;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
  align-content: center;
}

.boxboder:hover {
  border-color: #1890ff;

  .icon {
    color: #1890ff;
  }

  .delicon {
    color: #f00;
  }
}

.icon {
  transition: color 0.3s ease;
  color: rgba(0, 0, 0, 0.25);
  font-size: 1.125rem;
  margin: auto 20px;
}


/* 禁用状态样式 */
.boxboders {
  width: 100%;
  min-height: 120px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  transition: border-color 0.3s ease;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  cursor: not-allowed;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.25);
}

/* 禁用状态下的hover效果 */
.boxboders:hover {
  border-color: #d9d9d9;
  /* 保持灰色边框，不变成蓝色 */
  background-color: #f5f5f5;
  /* 保持灰色背景 */
}
</style>
